<template>
  <vs-popup
    id="rawMaterialConsumptionByBranchReport"
    :active.sync="isActive"
    background-color="rgb(248, 248, 248)"
    title="Hammadde Şube Tüketim Raporu"
    v-esc="escape"
  >
    <vs-row vs-type="flex" vs-w="12" vs-align="center" v-if="reportData && reportData.rawMaterial">
      <vs-col vs-type="flex" vs-w="11">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
          <span class="text-medium-small underline text-dark weight-600 text-center">
            {{ reportData.rawMaterial.name }}
          </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2">
            <span class="weight-500">Toplam Tüketim:</span>
            <b class="text-primary ml-2">{{ reportData.totalConsumptionSum.toLocaleString() }} {{ reportData.unitName }}</b>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2">
            <span class="weight-500">Toplam Maaliyet:</span>
            <b class="text-primary ml-2">{{ $toCurrency(reportData.totalConsumptionSumAmount) }}</b>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-w="1" vs-justify="flex-end" style="align-self: flex-start">
        <vx-tooltip text="Excel Export" position="top">
          <vs-button @click="getExcel" class="panel-action panel-action-box-shadow"
                     color="primary" icon-pack="feather" icon="icon-download" size="small">
          </vs-button>
        </vx-tooltip>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" v-if="reportData && reportData.branchConsumptions">
      <vs-row vs-type="flex" vs-w="12" id="materialReportBranchFilter" class="my-2">
        <vs-input v-model="filterString" class="w-full border-radius border-all" placeholder="Şube Arama"/>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="pt-1" vs-justify="space-between" id="rawMaterialConsumptionHead">
        <vs-col vs-type="flex" vs-w="4" vs-align="center">
          <span class="text-smaller weight-600">
          Şube
        </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span class="text-smaller weight-600">
          Birim
        </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="3" vs-align="center" vs-justify="center" class="">
          <span class="text-smaller weight-600">
          Miktar
        </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="3" vs-align="center" vs-justify="center" class="">
          <span class="text-smaller weight-600">
          Maaliyet
        </span>
        </vs-col>
      </vs-row>
      <vs-divider class="my-1"></vs-divider>
      <vs-row vs-type="flex" vs-w="12" class="py-1" vs-justify="space-between"
              v-for="(consumption,index) in (filteredList && filteredList.length > 0 ? filteredList : [])" :key="index">
        <div class="d-flex w-full justify-between border-bottom border-secondary py-1">
          <vs-col vs-type="flex" vs-w="4" vs-align="center">
          <span class="text-primary mr-2 text-xsmall weight-600">
            {{ (index + 1) + '.' }}
          </span>
            <span class="text-primary text-xsmall weight-600">
            {{ consumption.branch.name }}
          </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span class="text-secondary weight-600 text-xsmall w-full text-center">
            {{ reportData.unitName }}
          </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" vs-align="center">
            <span class="text-primary weight-600 text-xsmall w-full text-center">
                {{ consumption.consumptionSum.toLocaleString() }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" vs-align="center">
            <span class="text-primary weight-600 text-xsmall w-full text-center">
                {{ $toCurrency(consumption.consumptionSumAmount) }}
            </span>
          </vs-col>
        </div>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
export default {
  name: "RawMaterialConsumptionByBranch",
  props: {
    reportData: {
      required: false,
      type: Object
    },
    tableOptions: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      isActive: false,
      filterString: ""
    }
  },
  watch: {
    isActive(val) {
      if (!val) {
        this.$emit("clear")
      }
    }
  },
  methods: {
    escape() {
      if (this.isActive) this.isActive = false;
    },
    getExcel() {
      this.$emit("getExcel", this.reportData.rawMaterial.id)
    }
  },
  computed: {
    filteredList() {
      if (!this.filterString) return this.reportData.branchConsumptions
      return this.reportData.branchConsumptions.filter(x => x.branch.name.toLowerCase().includes(this.filterString.toLowerCase()))
    }
  },
}
</script>

<style scoped>

</style>
